export const Role = {
  Acquisition: "acquisition",
  Inventory: "inventory",
  Management: "management",
  Dealer: "dealer",
  DealerRetailer: "dealer-retailer",
  ServiceProvider: "service-provider",
  Distributor: "distributor",
  PDS: "pds",
  Finance: "finance",
};
